import { useState, useEffect } from 'react'

export function useViewerCount(initialCount: number = 121) {
  const [count, setCount] = useState(initialCount)

  useEffect(() => {
    const interval = setInterval(() => {
      // Increment by a random number between 1 and 3
      setCount((prev) => prev + Math.floor(Math.random() * 3) + 1)
    }, 4500)

    return () => clearInterval(interval)
  }, [])

  return count
}
